<template>
  <div id="home">
    <div id="home-bg">
      <div id="home-video">
        <video autoplay loop muted style="width: 100vw">
          <source src="../assets/hero.mp4" type="video/mp4">
        </video>
      </div>
      <div id="title">
        <div id="title-main">{{ $t('home_titolo') }}</div>
        <div id="title-sub">{{ $t('home_sottotitolo') }}</div>
      </div>
    </div>

    <div id="home-text">
      <div class="flex-column text-left " v-html="translatedMainContent"></div>
    </div>

    <div class="home-hr">
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
      <b-link to="/about" style="text-decoration: none;color: #2c3e50">
        <div class="home-hr-line">
          <div class="home-hr-text">
            {{ $t('approfondisci') }}
          </div>
        </div>
      </b-link>
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
    </div>

    <!-- --------------------- I VIRTUAL TOUR --------------------- -->

    <div class="home-subsection-div mb-5">
      <div class="home-subsection-title">{{ $t('home_subsection_virtualtour') }}</div>
      <div class="home-subsection-text" v-html="translatedVirtualTourContent"></div>

      <vueper-slides
          class="no-shadow"
          :visible-slides="2"
          :bullets="true"
          slide-multiple
          :gap="3"
          :dragging-distance="200"
          :breakpoints="{ 1000: { visibleSlides: 1, arrows: false, bulletsOutside: true, slideRatio: 1.3 / 1 },
           1300: { visibleSlides: 2, arrows: false, bulletsOutside: true, slideRatio: 1 / 1.3 } }">
        <vueper-slide v-for="location in filteredGoogleACLocations" :key="location.id" :image="location.preview"
                      :link="location.link" openInNew="true">
          <template #content>
            <div style="display:flex; flex-direction: row; background: linear-gradient(360deg, #091832 9.9%, rgba(9, 24, 50, 0) 100%); height: 100%">
              <div style="display:flex; flex-direction: column; justify-content: flex-end;margin: 0 0 20px 20px">
                <img src="../assets/map-pin.svg" style="width:50px" alt="map pin"/>
              </div>
              <div style="display:flex; flex-direction: column; justify-content: flex-end;">
                <div class="home-googleac-title1">{{ location.struttura }}</div>
                <div class="home-googleac-title2">{{ location.titolo }}</div>
              </div>
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>
    <div class="home-hr">
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
      <b-link to="/googlearts" style="text-decoration: none;color: #2c3e50">
        <div class="home-hr-line">
          <div class="home-hr-text">
            {{ $t('scopri_tour') }}
          </div>
        </div>
      </b-link>
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
    </div>

    <!-- --------------------- LE AREE TEMATICHE --------------------- -->

    <div class="home-subsection-div mb-3">
      <div class="home-subsection-title">{{ $t('home_subsection_aree_tematiche') }}</div>
    </div>

    <div class="home-subsection-div mb-5" style="">
      <vueper-slides
          class="no-shadow"
          :visible-slides="4"
          :slide-ratio="1 / 3"
          :arrows="true"
          bullets
          bullets-outside
          slide-multiple
          :gap="3"
          :dragging-distance="200"
          :breakpoints="{ 1000: { visibleSlides: 1, arrows: false, slideRatio: 1  },
           1300: { visibleSlides: 2, arrows: true, slideRatio: 1 / 2 },
           1700: { visibleSlides: 3, arrows: true, slideRatio: 1 / 2.5 } }">
        <vueper-slide :image="require('@/assets/sistema_museale.jpg')" link="/collectionsall">
          <template #content>
            <div style="display:flex; flex-direction: row; background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 25%, rgba(6, 19, 39, 0.1) 50%, rgba(9, 24, 50, 0) 100%); height: 100%">
              <div style="height: 100%; padding: 0" class="home-aree-tematiche-title">
                <div style="position: absolute; bottom: 0;padding: 20px;">
                  {{ $t('menu.scopri_sistemamuseale') }}
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
        <vueper-slide :image="require('@/assets/scavi.jpg')" link="/archaeological">
          <template #content>
            <div style="display:flex; flex-direction: row; background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 25%, rgba(6, 19, 39, 0.1) 50%, rgba(9, 24, 50, 0) 100%); height: 100%">
              <div style="height: 100%; padding: 0" class="home-aree-tematiche-title">
                <div style="position: absolute; bottom: 0;padding: 20px;">
                  {{ $t('menu.scopri_scavi') }}
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
        <vueper-slide :image="require('@/assets/palazzi_storici.jpg')" link="/assets/120">
          <template #content>
            <div style="display:flex; flex-direction: row; background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 25%, rgba(6, 19, 39, 0.1) 50%, rgba(9, 24, 50, 0) 100%); height: 100%">
              <div style="height: 100%; padding: 0" class="home-aree-tematiche-title">
                <div style="position: absolute; bottom: 0;padding: 20px;">
                  {{ $t('menu.scopri_palazzi') }}
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
        <vueper-slide :image="require('@/assets/archivi.jpg')" link="/archives">
          <template #content>
            <div style="display:flex; flex-direction: row; background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 25%, rgba(6, 19, 39, 0.1) 50%, rgba(9, 24, 50, 0) 100%); height: 100%">
              <div style="height: 100%; padding: 0" class="home-aree-tematiche-title">
                <div style="position: absolute; bottom: 0;padding: 20px;">
                  {{ $t('menu.scopri_archivi') }}
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
        <vueper-slide :image="require('@/assets/orchestra.jpg')" link="/orchestra">
          <template #content>
            <div style="display:flex; flex-direction: row; background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 25%, rgba(6, 19, 39, 0.1) 50%, rgba(9, 24, 50, 0) 100%); height: 100%">
              <div style="height: 100%; padding: 0" class="home-aree-tematiche-title">
                <div style="position: absolute; bottom: 0;padding: 20px;">
                  {{ $t('menu.scopri_orchestra') }}
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>

    <div class="home-hr">
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
      <b-link to="/collectionsall" style="text-decoration: none;color: #2c3e50">
        <div class="home-hr-line">
          <div class="home-hr-text">
            {{ $t('scopri_collezioni') }}
          </div>
        </div>
      </b-link>
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
    </div>

    <!-- --------------------- I NOSTRI BENI --------------------- -->

    <div class="home-subsection-div">
      <div class="home-subsection-title">{{ $t('home_subsection_nostri_beni') }}</div>
      <div style="position: relative">
        <b-card-group columns id="home-cards-beni">
          <b-link
              v-for="(asset, index) in assets"
              :to="'/asset/' + asset.id"
              :key="asset.id">
            <b-card
                columns
                overlay
                style="margin: 20px"
                border-variant="dark"
                :class="'home-cards-beni-' + (index > 3 ? 'hidden' : 'visible')"
                :img-src="asset.image"
                :img-alt="$utilities.getTranslation(asset, 'nome', $i18n.locale)"
            ></b-card>
          </b-link>
        </b-card-group>
        <div id="home-cards-beni-gradient"></div>
      </div>
    </div>

    <div class="home-hr">
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
      <b-link to="/assetssearch" style="text-decoration: none;color: #2c3e50">
        <div class="home-hr-line">
          <div class="home-hr-text">
            {{ $t('scopri_beni') }}
          </div>
        </div>
      </b-link>
      <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
    </div>

    <!-- --------------------- UNIMI PER I MUSEI --------------------- -->

    <div class="home-subsection-div">
      <div class="home-subsection-title">{{ $t('home_subsection_nei_musei') }}</div>
      <div class="home-subsection-text" v-html="translatedInMuseumsContent"></div>

      <vueper-slides
          id="vueperslidesInMuseums"
          ref="vueperslidesInMuseums"
          class="no-shadow"
          :visible-slides="2"
          slide-multiple
          fixed-height="140px"
          arrows-outside
          bullets-outside
          :breakpoints="{ 1300: { visibleSlides: 1, fixedHeight: 140, arrows: false },
            1000: { visibleSlides: 1, fixedHeight: 220, arrows: false } }">
        <vueper-slide
            v-for="coll in inMuseums"
            :key="coll.id"
            style="display: flex; align-items: center;justify-content: center;"
            @click.native="setCurrentInMuseums(coll.id)">
          <template #content>
            <div class="maplinks-text-black" :id="'inmuseums-' + coll.id" :style="(currentInMuseumsId == coll.id ? 'text-decoration: underline;' : '')">{{ $utilities.getTranslation(coll, "titolo", $i18n.locale) }}</div>
          </template>

          <template #arrow-right>
            <i class="icon icon-arrow-right" />
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>

    <div class="mb-5">
      <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
              data-projection="EPSG:4326" ref="mapInMuseums" @created="mapCreatedInMuseums" style="height: min(600px, 50vh)">

        <vl-view :min-zoom="5" :zoom.sync="inMuseumsZoom" :center.sync="inMuseumsCenter" ></vl-view>

        <vl-layer-tile id="osm" :overlay="true">
          <vl-source-osm></vl-source-osm>
        </vl-layer-tile>

        <vl-overlay
            class="map-overlay"
            v-for="coll in inMuseums"
            :key="coll.id"
            :position="[coll.luogo.longitudine, coll.luogo.latitudine]">
          <template>
            <div :class="currentInMuseumsId == coll.id? 'map-circle-on' : 'map-circle-off'" @click="openLocationInMuseums(coll.id)" style="cursor: pointer"></div>
          </template>
        </vl-overlay>

      </vl-map>
    </div>

    <div class="home-inmuseums-content mb-5" v-if="currentInMuseumsId != null">
      <div style="font-size: 20px;line-height: 40px;font-weight: 700;letter-spacing: 0.1em;text-transform: capitalize;">{{ translatedInMuseumsTitle }}</div>
      <div style="font-size: 20px;line-height: 126%;" v-html="translatedInMuseumsText"></div>
    </div>

    <div class="home-hr">
      <div style="width: 100%; height: 53px; margin: 25px 0 0 0;">
        <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
      </div>
    </div>

    <!-- --------------------- GLI SCAVI ARCHEOLOGICI --------------------- -->
    <div class="home-subsection-div-dark">
      <div class="home-subsection-div mb-5">
        <div class="home-subsection-title text-white">{{ $t('home_subsection_scavi') }}</div>

        <vueper-slides
            id="vueperslidesArcheo"
            ref="vueperslidesArcheo"
            class="no-shadow"
            :visible-slides="2"
            slide-multiple
            fixed-height="100px"
            arrows-outside
            bullets-outside
            :breakpoints="{ 1300: { visibleSlides: 1, fixedHeight: 100, arrows: false },
          1000: { visibleSlides: 1, fixedHeight: 220, arrows: false } }">
          <vueper-slide
              v-for="coll in archeoCollections"
              :key="coll.id"
              style="display: flex; align-items: center;justify-content: center;"
              @click.native="setCurrentArcheo(coll.id)">
            <template #content>
              <div style="background-color: #091832;">
                <div class="maplinks-text-orange" :id="'archeo-' + coll.id" :style="(currentArcheoId == coll.id ? 'text-decoration: underline;' : '')">{{ getPlaceTranslation(coll.luogo.record) }}</div>
              </div>
            </template>
          </vueper-slide>
        </vueper-slides>
      </div>

      <div class="mb-5">
        <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                data-projection="EPSG:4326" ref="mapArcheo" @created="mapCreatedArcheo" controls="false" style="height: min(600px, 50vh)">

          <vl-view :min-zoom="5" :zoom.sync="archeoZoom" :center.sync="archeoCenter" ></vl-view>

          <vl-layer-tile id="osm" :overlay="true">
            <vl-source-osm></vl-source-osm>
          </vl-layer-tile>

          <vl-overlay
              class="map-overlay"
              v-for="coll in archeoCollections"
              :key="coll.id"
              :position="[coll.luogo.longitudine, coll.luogo.latitudine]">
            <template>
              <div :class="currentArcheoId == coll.id? 'map-circle-on' : 'map-circle-off'" @click="openLocationArcheo(coll.id)" style="cursor: pointer"></div>
            </template>
          </vl-overlay>

        </vl-map>
      </div>

      <div class="home-archeo-content" v-if="currentArcheoId != null">
        <div class="home-archeo-content-left">
          <div style="color: #DCAC00;font-size: 20px;line-height: 40px;font-weight: 700;letter-spacing: 0.1em;text-transform: capitalize;">{{ translatedArcheoTitle }}</div>
          <div class="text-white" style="font-size: 20px;line-height: 126%;" v-html="translatedArcheoText"></div>
        </div>
        <div class="home-archeo-content-right">
          <b-img
              v-if="currentArcheoCollection != null"
              :src="currentArcheoCollection.immagine"
              :alt="translatedArcheoTitle"
              fluid right
          />
        </div>
      </div>

      <div class="home-hr">
        <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
          <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
        </div>
        <b-link to="/archaeological" style="text-decoration: none;color: #2c3e50">
          <div class="home-hr-line">
            <div class="home-hr-text" style="color: #DCAC00">
              {{ $t('scopri_scavi') }}
            </div>
          </div>
        </b-link>
        <div style="width: 45%; height: 53px; margin: 25px 0 0 0;">
          <hr style="border-top: 2px solid #DCAC00;margin: 0"/>
        </div>
      </div>
    </div>

    <!-- --------------------- NEWS --------------------- -->

    <div class="home-subsection-div mb-5">
      <div class="home-subsection-title">{{ $t('home_subsection_news') }}</div>
      <div class="home-subsection-text" v-html="translatedNewsContent"></div>
    </div>
  </div>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'Home',
  components: {VueperSlides, VueperSlide},
  data: function () {
    return {
      content: "",
      googleACLocations: [],
      assets: null,
      archeoCollections: null,
      inMuseums: null,
      currentArcheoId: null,
      currentInMuseumsId: null,
      archeoCenter: [22,41],
      archeoZoom: 4,
      inMuseumsCenter: [10,45],
      inMuseumsZoom: 8,
    };
  },
  created() {
    this.fetchPage();
    this.fetchGoogleAC();
    this.fetchImages();
    this.fetchArcheoCollections();
    this.fetchInMuseums();
  },
  computed: {
    translatedMainContent() {
      const content = this.content;
      return this.$utilities.getTranslationSubField(content, "nome", "home", "contenuto", this.$i18n.locale);
    },
    translatedVirtualTourContent() {
      const content = this.content;
      return this.$utilities.getTranslationSubField(content, "nome", "home_virtual_tour", "contenuto", this.$i18n.locale);
    },
    translatedInMuseumsContent() {
      const content = this.content;
      return this.$utilities.getTranslationSubField(content, "nome", "nei_musei", "contenuto", this.$i18n.locale);
    },
    translatedNewsContent() {
      const content = this.content;
      return this.$utilities.getTranslationSubField(content, "nome", "news", "contenuto", this.$i18n.locale);
    },
    currentArcheoCollection() {
      for (let coll in this.archeoCollections)
        if (this.archeoCollections[coll].id == this.currentArcheoId)
          return this.archeoCollections[coll];
      return null;
    },
    translatedArcheoTitle() {
      for (let coll in this.archeoCollections)
        if (this.archeoCollections[coll].id == this.currentArcheoId)
          return this.$utilities.getTranslation(this.archeoCollections[coll], "nome", this.$i18n.locale);
      return "";
    },
    translatedArcheoText() {
      for (let coll in this.archeoCollections)
        if (this.archeoCollections[coll].id == this.currentArcheoId)
          return this.$utilities.getTranslation(this.archeoCollections[coll], "descrizione", this.$i18n.locale);
      return "";
    },
    translatedInMuseumsTitle() {
      for (let coll in this.inMuseums)
        if (this.inMuseums[coll].id == this.currentInMuseumsId)
          return this.$utilities.getTranslation(this.inMuseums[coll], "titolo", this.$i18n.locale);
      return "";
    },
    translatedInMuseumsText() {
      for (let coll in this.inMuseums)
        if (this.inMuseums[coll].id == this.currentInMuseumsId)
          return this.$utilities.getTranslation(this.inMuseums[coll], "descrizione", this.$i18n.locale);
      return "";
    },
    filteredGoogleACLocations() {
      const locations = this.googleACLocations;
      for (let location in locations) {
        // Compila titolo
        locations[location].titolo = this.$utilities.getTranslation(locations[location], "titolo", this.$i18n.locale);
        locations[location].struttura = this.$utilities.getTranslation(locations[location], "struttura", this.$i18n.locale);
      }

      let result = locations;
      // Sort
      return result.sort((a, b) => {
        return a.ordine - b.ordine;
      })
    },
    filteredAssets() {
      let assets = this.assets;
      return assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
    },
  },
  methods: {
    mapCreatedArcheo() {
      // if (this.$refs.mapArcheo.$map.getInteractions().clear() != null)
      //   this.$refs.mapArcheo.$map.getInteractions().clear().extend(interactions.defaults({
      //     mouseWheelZoom: false,
      //   }))
    },
    mapCreatedInMuseums() {
      // if (this.$refs.mapInMuseums.$map.getInteractions().clear() != null)
      //   this.$refs.mapInMuseums.$map.getInteractions().clear().extend(interactions.defaults({
      //     mouseWheelZoom: false,
      //   }))
    },
    setCurrentArcheo(id) {
      this.currentArcheoId = id;
      for (let coll in this.archeoCollections)
        if (this.archeoCollections[coll].id == id)
          this.$refs.mapArcheo.$map.getView().fit(this.$refs.mapArcheo.pointToViewProj(
              [this.archeoCollections[coll].luogo.longitudine - 0.1, this.archeoCollections[coll].luogo.latitudine - 0.1]).concat(this.$refs.mapArcheo.pointToViewProj(
              [this.archeoCollections[coll].luogo.longitudine + 0.1, this.archeoCollections[coll].luogo.latitudine + 0.1])));
    },
    setCurrentInMuseums(id) {
      this.currentInMuseumsId = id;
      for (let coll in this.inMuseums)
        if (this.inMuseums[coll].id == id)
          this.$refs.mapInMuseums.$map.getView().fit(this.$refs.mapInMuseums.pointToViewProj(
              [this.inMuseums[coll].luogo.longitudine - 0.1, this.inMuseums[coll].luogo.latitudine - 0.1]).concat(this.$refs.mapInMuseums.pointToViewProj(
              [this.inMuseums[coll].luogo.longitudine + 0.1, this.inMuseums[coll].luogo.latitudine + 0.1])));
    },
    getPlaceTranslation(place) {
      return this.$utilities.getTranslation(place, "denominazione", this.$i18n.locale);
    },
    async fetchPage() {
      const contentData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            in: ['home', 'home_virtual_tour', 'nei_musei', 'news']
          }
        }
      });
      this.content = contentData.data;
    },
    async fetchGoogleAC() {
      // Recupera i luoghi Street View
      const googleACIdsData = await this.$client.getItems("home_settings", {
        fields: ["*"],
        filter: {
          nome_parametro: {
            eq: 'google_ac_ids'
          }
        }
      });
      let googleACIds = googleACIdsData.data[0].valore_parametro;
      const locationsData = await this.$client.getItems("streetview", {
        fields: ["*", "traduzioni.*"], filter: {
          id: {
            in: googleACIds
          }
        }
      });
      let locations = locationsData.data;
      let listOfIdDirectusFiles = "";
      for (let location in locations) {
        const defaultImageUrl = await this.$client.getAssetUrl("cl4ladr0lo8w4ck0", {key: "directus-large-contain"});
        if (locations[location].preview != null) {
          listOfIdDirectusFiles += locations[location].preview.id + ",";
        } else {
          locations[location].preview = defaultImageUrl;
        }
      }

      const filesData = await this.$client.getFiles({
        limit: -1, filter: {
          id: {
            in: listOfIdDirectusFiles
          }
        }
      });
      let files = filesData.data;
      for (let location in locations) {
        for (let file in files) {
          const imageId = "" + locations[location].preview.id;
          if (files[file].id == imageId) {
            locations[location].preview = await this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
          }
        }
      }
      this.googleACLocations = locations.sort((a, b) => (a.titolo > b.titolo) ? 1 : ((b.titolo > a.titolo) ? -1 : 0));
    },
    async fetchImages() {
      // Recupera le immagini scelte
      const assetsIdsData = await this.$client.getItems("home_settings", {
        fields: ["*"],
        filter: {
          nome_parametro: {
            eq: 'home_assets'
          }
        }
      });
      let assetsIds = assetsIdsData.data[0].valore_parametro;
      const assetsData = await this.$client.getItems("beni", {fields: ["id", "traduzioni.*"], limit: -1, filter: {
          id: {
            in: assetsIds
          }}});
      let assets = assetsData.data;
      let listOfAssetIds = "";
      for (let asset in assets) {
        listOfAssetIds += assets[asset].id + ",";
      }

      const joinsData = await this.$client.getItems("join_beni_directus_files", {fields: ["*"], limit: -1, filter: {
          id_beni: {
            in: listOfAssetIds
          }}});
      let joins = joinsData.data;
      let listOfIdDirectusFiles = "";
      for (let join in joins) {
        listOfIdDirectusFiles += joins[join].id_directus_files + ",";
      }

      const filesData = await this.$client.getFiles({limit: -1, filter: {
          id: {
            in: listOfIdDirectusFiles
          }}});
      let files = filesData.data;

      for (let asset in assets) {
        assets[asset].order = Number.MAX_VALUE;
        assets[asset].image = null;
        assets[asset].numImages = 0;
        for (let join in joins) {
          if (assets[asset].id === joins[join].id_beni) {
            assets[asset].numImages++;
            const imageId = "" + joins[join].id_directus_files;
            for (let file in files) {
              if (files[file].id != imageId)
                continue;
              // Immagini
              let assetUrl = this.$client.getAssetUrl(files[file].private_hash, {key: "directus-large-contain"});
              // Ordine di visualizzazione delle immagini (se esiste)
              if (files[file].metadata != null && files[file].metadata.order != null) {
                if (assets[asset].order > files[file].metadata.order) { // si prende l'immagine con order minimo
                  assets[asset].order = files[file].metadata.order;
                  assets[asset].image = assetUrl;
                }
              }
              if (assets[asset].image == null) { // se non è specificato order assegna comunque l'immagine
                assets[asset].image = assetUrl;
              }
            }
          }
        }
      }
      this.assets = assets.sort((a, b) => parseInt(a.order) - parseInt(b.order));
    },
    // Recupera le collezioni di scavi archeologici
    async fetchArcheoCollections() {
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["*", "traduzioni.*"], filter: {
          tipologia: {
            eq: 'scavo'
          },
          luogo: {
            neq: null
          }
        }
      });
      let collections = collectionsData.data;
      let placesIds = "";
      for (let coll in collections) {
        const defaultImageUrl = await this.$client.getAssetUrl("cl4ladr0lo8w4ck0", {key: "directus-large-contain"});
        if (collections[coll].immagine != null) {
          const imageId = "" + collections[coll].immagine.id;
          const fileData = await this.$client.getFile(imageId);
          collections[coll].immagine = fileData;
          let file = fileData.data;
          collections[coll].immagine = await this.$client.getAssetUrl(file.private_hash, {key: "directus-large-contain"});
        } else {
          collections[coll].immagine = defaultImageUrl;
        }
        placesIds += collections[coll].luogo.id + ",";
      }

      const places = await this.$client.getItems("luoghi", {
        fields: ["id", "longitudine", "latitudine", "traduzioni.*"], limit: -1, filter: { id: { in: placesIds } }
      });
      let placesData = places.data;
      for (let coll in collections) {
        if (collections[coll].luogo != null) {
          for (let i in placesData) {
            if (placesData[i].id == collections[coll].luogo.id) {
              collections[coll].luogo.record = placesData[i];
              collections[coll].luogo.longitudine = placesData[i].longitudine;
              collections[coll].luogo.latitudine = placesData[i].latitudine;
            }
          }
        }
      }

      this.archeoCollections = collections.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
      this.loading = "";
    },
    // Recupera nei musei e per i musei
    async fetchInMuseums() {
      const inMuseumsData = await this.$client.getItems("nei_musei", {fields: ["*", "traduzioni.*"], filter: {
          luogo: {
            neq: null
          }
        }
      });
      let inMuseums = inMuseumsData.data;
      let placesIds = "";
      for (let i in inMuseums) {
        placesIds += inMuseums[i].luogo.id + ",";
      }

      const places = await this.$client.getItems("luoghi", {
        fields: ["id", "longitudine", "latitudine"], limit: -1, filter: { id: { in: placesIds } }
      });
      let placesData = places.data;
      for (let coll in inMuseums) {
        if (inMuseums[coll].luogo != null) {
          for (let i in placesData) {
            if (placesData[i].id == inMuseums[coll].luogo.id) {
              inMuseums[coll].luogo.longitudine = placesData[i].longitudine;
              inMuseums[coll].luogo.latitudine = placesData[i].latitudine;
            }
          }
        }
      }

      this.inMuseums = inMuseums.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
      this.loading = "";
    },
    openLocationArcheo(id) {
      document.getElementById("archeo-" + id).click();
    },
    openLocationInMuseums(id) {
      document.getElementById("inmuseums-" + id).click();
    },
  }
}
</script>
